import React from 'react';
import { ProductHat as PackagePickerHat } from '@wix/package-picker-components';
import { observer } from 'mobx-react';
import { useHatProperties } from './useHatProperties';

interface ProductHatProps {
  isCurrentPlan: boolean;
  isOnSale: boolean;
  isRecommended: boolean;
  text?: string;
  salePercentages?: number;
  isAllProductsOnSale?: boolean;
}

const ProductHatComp: React.FC<ProductHatProps> = ({
  isCurrentPlan,
  isOnSale,
  isRecommended,
  text,
  salePercentages,
  isAllProductsOnSale,
}) => {
  const hatProperties = useHatProperties({
    isCurrentPlan,
    isOnSale,
    isRecommended,
    text,
    salePercentages,
    isAllProductsOnSale,
  });
  return hatProperties ? (
    <PackagePickerHat {...hatProperties} dataHook='product-hat' />
  ) : null;
};

export const ProductHat = observer(ProductHatComp);
